(ns common.schema.entities.change-meta
  (:require [common.data-types :as data-types]
            [common.schema.schema-utils :as su]))


(def schema
  (vec
    (concat (su/keyword-field :change/type "Change type" [] {:default-field-visibility :in-use-disabled})
            (su/text-edn-field :change/value "Change value" {:default-field-visibility :in-use-disabled})
            (su/text-edn-field :change/old-value "Change old value" {:default-field-visibility :in-use-disabled})
            (su/calculated-field :change/old-value-id
                                 "old UUID"
                                 {:default-field-visibility :in-use-disabled
                                  :data-type                :data.type/id
                                  :calculation-triggers     {}
                                  :calc-fn                  (fn [{:keys [entity-data]}]
                                                              (let [old-value (->> entity-data
                                                                                   :change/old-value
                                                                                   (data-types/parse-edn-string))]
                                                                (when (number? old-value)
                                                                  old-value)))})
            (su/text-edn-field :change/new-value "Change new value" {:default-field-visibility :in-use-disabled})
            (su/calculated-field :change/new-value-id
                                 "new UUID"
                                 {:default-field-visibility :in-use-disabled
                                  :data-type                :data.type/id
                                  :calculation-triggers     {}
                                  :calc-fn                  (fn [{:keys [entity-data]}]
                                                              (let [old-value (->> entity-data
                                                                                   :change/new-value
                                                                                   (data-types/parse-edn-string))]
                                                                (when (number? old-value)
                                                                  old-value)))}))))
